module.exports = __webpack_public_path__ + "assets/img/website-logo_105_FL.39133b27.png";